<template>
  <div class="wrapper">
    <div class="title-wrap">
      <h1 class="title">{{ title }}</h1>
      <div class="cover"></div>
    </div>
    <p>{{ pTag }}</p>

    <router-link to="/">
      <div class="angle enter active" id="go-lower">Подробнее</div>
    </router-link>

    <div class="go-down"></div>
  </div>
</template>

<script>
export default {
  name: "timer",
  props: {
    title: String,
    pTag: String,
  },
};
</script>

<style scoped>
.title-wrap {
  position: relative;
  margin-left: 20px;
}

.cover {
  height: 4.5vh;
  position: absolute;
  background-color: #2778f3;
  top: 0;
  right: 0;
  transform: translateX(-20px);
}

.menu-icon {
  position: absolute;
  top: 30px;
  right: 30px;
  width: 30px;
  height: 30px;
  background-image: url("../assets/menu.svg");
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
}

.wrapper p {
  width: 25vw;
  margin-top: 25px;
  margin-left: 20px;
  position: relative;
  font-size: calc(0.5vw + 0.5vh + 0.4vmin);
}

.wrapper h1 {
  font-size: calc(1vw + 1vh + 0.7vmin);
}

.wrapper {
  position: absolute;
  left: 10%;
  top: 50%;
  transform: translateY(-50%);
}

.call-center {
  display: flex;
  height: 100vh;
  flex-direction: column;
  animation: alpha 1s;
}

.logo-text {
  width: 13vw;
  position: absolute;
  top: 30px;
  left: 30px;
}

.enter {
  text-align: center;
  background-color: #2778f3;
  padding: 8px;
  width: 14vw;
  font-size: calc(0.7vw + 0.6vh + 0.5vmin);
  color: white;
  text-decoration: none;
  position: relative;
  margin-top: 30px;
  margin-left: 20px;
  display: none;
}

.go-down {
  width: 40px;
  height: 40px;
  background-image: url("../assets/arrow.svg");
  background-size: contain;
  transform: rotate(-90deg);
  margin: 20px auto;
  display: none;
  z-index: 20;
}

@media only screen and (max-width: 900px) {
  .go-down {
    display: none;
    position: absolute;
    left: 50%;
    transform: translateX(-50%) rotate(-90deg);
    bottom: 10px;
  }

  .enter {
    display: none !important;
  }

  .wrapper p {
    width: calc(100vw - 50px);
    margin-left: 0px;
    font-size: unset;
  }

  .wrapper h1 {
    font-size: 27px;
  }

  .cover {
    height: 35px;
  }

  .wrapper {
    position: relative;
    left: 30px;
    bottom: 5%;
    height: 50vh;
    top: unset;
    transform: unset;
    width: 80vw;
  }
}
</style>
